document.addEventListener("DOMContentLoaded", function() {

    // swiper výpis nemovitostí
    //=========================
    (function () {
        const swiperSelector = document.querySelectorAll('[data-estates-swiper]');
        if (!swiperSelector.length) return;

        swiperSelector.forEach(el => {
            const swiperWrapper = el.closest('.swiper-design');
            const paginationEl = swiperWrapper.querySelector('.swiper-pagination'),
                navigationPrevEl = swiperWrapper.querySelector('.swiper-button-prev'),
                navigationNextEl = swiperWrapper.querySelector('.swiper-button-next');

            const articlesSwiper = new Swiper(el, {
                slidesPerView: 4,
                spaceBetween: 15,
                pagination: {
                    el: paginationEl,
                    type: 'bullets',
                    renderBullet: function (index, className) {
                        return `<span class="${className}" data-bullet-index="${index}"></span>`;
                    }
                },
                navigation: {
                    prevEl: navigationPrevEl,
                    nextEl: navigationNextEl
                },
                breakpoints: {
                    320: { slidesPerView: 1 },
                    480: { slidesPerView: 2 },
                    992: { slidesPerView: 3 },
                    1300: { slidesPerView: 4 },
                    1850: { spaceBetween: 40 }
                },
                watchOverflow: true,
                on: {
                    init: function () {
                        setTimeout(() => updateBullets(this), 0); // zaručí, že pagination.bullets už existují
                    },
                    slideChange: function () {
                        updateBullets(this);
                    },
                    resize: function() {
                        updateBullets(this);
                    }
                }
            });

            function updateBullets(swiperInstance) {
                const bullets = swiperInstance.pagination && swiperInstance.pagination.bullets;
                if (!bullets || typeof bullets.forEach !== 'function') return;

                const active = swiperInstance.realIndex;
                const total = bullets.length;

                bullets.forEach((bullet, index) => {
                    // Zobrazíme bullet, pokud je v rozsahu aktivní -1 až aktivní +1
                    // ALE zároveň se postaráme o začátek a konec
                    if (
                        (active <= 1 && index <= 2) ||                   // první 3
                        (active >= total - 2 && index >= total - 3) ||   // poslední 3
                        (index >= active - 1 && index <= active + 1)     // prostřední 3
                    ) {
                        bullet.classList.remove('u-hidden');
                    } else {
                        bullet.classList.add('u-hidden');
                    }
                });
            }
        });
    }());
});